import { Directive, ElementRef, EventEmitter, HostListener, Input, OnDestroy, Output } from '@angular/core';

@Directive({
  selector: '[appLongPress]',
  standalone: true,
})
export class LongPressDirective implements OnDestroy {
  @Input() longPressDelay = 550;
  @Output() longPress = new EventEmitter<void>();

  private pressTimer: ReturnType<typeof setTimeout> | null = null;
  private suppressNextClick = false;
  private readonly captureClickListener = (event: Event): void => {
    if (!this.suppressNextClick) {
      return;
    }

    event.preventDefault();
    event.stopPropagation();
    if (typeof event.stopImmediatePropagation === 'function') {
      event.stopImmediatePropagation();
    }

    this.suppressNextClick = false;
  };

  constructor(private elementRef: ElementRef<HTMLElement>) {
    this.elementRef.nativeElement.addEventListener('click', this.captureClickListener, true);
  }

  @HostListener('pointerdown')
  onPointerDown(): void {
    this.cancelPressTimer();
    this.suppressNextClick = false;

    this.pressTimer = setTimeout(() => {
      this.pressTimer = null;
      this.suppressNextClick = true;
      this.longPress.emit();
    }, this.longPressDelay);
  }

  @HostListener('pointerup')
  @HostListener('pointerleave')
  @HostListener('pointercancel')
  @HostListener('blur')
  onPointerEnd(): void {
    this.cancelPressTimer();
  }

  ngOnDestroy(): void {
    this.elementRef.nativeElement.removeEventListener('click', this.captureClickListener, true);
  }

  private cancelPressTimer(): void {
    if (this.pressTimer) {
      clearTimeout(this.pressTimer);
      this.pressTimer = null;
    }
  }
}